import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% { opacity: 0.55; }
  50% { opacity: 1; }
  100% { opacity: 0.55; }
`

export const SkeletonLine = styled.span`
  display: block;
  height: ${({ $h }) => $h || 12}px;
  width: ${({ $w }) => $w || '100%'};
  border-radius: 5px;
  background: #ececed;
  animation: ${pulse} 1.2s ease-in-out infinite;
`

export const SkeletonBlock = styled.span`
  display: block;
  height: ${({ $h }) => $h || 64}px;
  width: ${({ $w }) => $w || '100%'};
  border-radius: ${({ $r }) => $r || '12px'};
  background: #ececed;
  animation: ${pulse} 1.2s ease-in-out infinite;
`

export const SkeletonRows = ({ rows = 6, gap = 14, widths = ['40%', '18%', '14%'] }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap, padding: '8px 0' }} aria-busy='true' aria-label='Loading'>
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        {widths.map((w, j) => (
          <SkeletonLine key={j} $w={w} />
        ))}
      </div>
    ))}
  </div>
)
